import { useLandingSectionTracking } from '@/hooks/useLandingSectionTracking';
import { useTranslation } from '@/i18n/i18n';

const featureItems = [
  {
    title: 'biura.features.1.title',
    description: 'biura.features.1.description',
  },
  {
    title: 'biura.features.2.title',
    description: 'biura.features.2.description',
  },
  {
    title: 'biura.features.3.title',
    description: 'biura.features.3.description',
  },
] as const;

export function BiuraFeatures() {
  const sectionRef = useLandingSectionTracking('biura_features');
  const { t } = useTranslation();

  return (
    <section
      ref={sectionRef}
      className="px-6 md:px-8 py-14 bg-muted/40 border-b border-border"
      aria-labelledby="biura-features-heading"
    >
      <div className="max-w-6xl mx-auto">
        <div className="max-w-2xl mb-10">
          <h2
            id="biura-features-heading"
            className="text-3xl md:text-4xl font-semibold tracking-tight"
          >
            {t('biura.features.heading')}
          </h2>
          <p className="mt-4 text-muted-foreground text-lg">{t('biura.features.subheading')}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {/* Evidence-artifact cards (DESIGN.md §Components): crisp border = "this
              is a dowód"; mono tabular index instead of icons-in-circles. */}
          {featureItems.map((item, index) => (
            <div
              key={item.title}
              className="rounded-2xl border border-foreground/20 bg-background p-6 h-full"
            >
              <p className="font-mono tabular-nums text-sm text-muted-foreground mb-4">
                0{index + 1}
              </p>
              <h3 className="text-xl font-semibold mb-3">{t(item.title)}</h3>
              <p className="text-muted-foreground leading-relaxed">{t(item.description)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
